export default __webpack_public_path__ + "static/media/proclamation3.4de6e031.jpg";